import { render, staticRenderFns } from "./UbrTicketOrder.vue?vue&type=template&id=7b097fce&scoped=true"
import script from "./UbrTicketOrder.vue?vue&type=script&lang=js"
export * from "./UbrTicketOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b097fce",
  null
  
)

export default component.exports